/** Injected at CI build time for production. */
export const API_BASE_URL = 'https://api.galopa.com.au';
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51TzNItCCswhaBK5CfZA5ripwW0ezeCu7qHZ6U2hK4m8lu1zeUffPRyLCPGYzYEfskThZXqryrh7H24W80c1VVB5s00Nb5CXhwC';
